import angleDistance from "../angleDistance";
import { isDigit, makeTransitionComps } from "../utils"

const BACKGROUND_COLOR_HEX = "#8bac0f"
const FOREGROUND_COLOR_HEX = "#306230"


/**
 * @typedef {import("kaplay").KAPLAYCtx} k
 */


/**
 * @param {k} k 
 */
export function game(k) {

  const foregroundColor = k.Color.fromHex(FOREGROUND_COLOR_HEX)
  const backgroundColor = k.Color.fromHex(BACKGROUND_COLOR_HEX)

  const FLOWER_ROTATION_SPEED = 150
  const MAX_PLANT_NUMBER = 4

  k.add(makeTransitionComps(k, () => {
    k.play("bg", {
      loop: true
    })
  }, true))


  function generateStars(k, max_star_count) {
    for (let i = 0; i < max_star_count; i++) {
      k.add([
        k.pos(k.rand(0, k.width()), k.rand(0, k.width() / 2)),
        k.circle(2),
        k.color(foregroundColor),
        k.z(-99),
      ]);
    }
  }

  function generateQuest() {
    const amountOfItems = k.randi(1, 4)
    let quests = []

    for (let index = 0; index < amountOfItems; index++) {
      const randomPlantNumber = k.randi(1, MAX_PLANT_NUMBER + 1)

      quests.push({ name: "plant_" + randomPlantNumber, done: false, angle: k.randi(360) })

    }

    return quests
  }

  function shopper() {

    let items = generateQuest()
    let isMenuVisible = false
    let currentItemIndex = 0

    let menu = null

    let errors = 0


    return {
      id: "shopper",
      add() {
        const itemMenu = this.add(makeShopBubble(items))

        const timeline =
          this.add([
            k.pos(0, - 60),
            k.anchor("center"),
            k.rect(60, 1)
          ])

        menu = itemMenu
        menu.hidden = true
        timeline.hidden = true
      },
      addError() {

        k.play("error")
        if (errors >= 2) {
          currentCustomer.ready = false
          menu.hidden = true

          this.add([
            k.sprite("tear"),
            k.scale(0.5),
            k.opacity(),
            k.pos(-4, -20),
            k.move(k.vec2(0, 1), 10),
            k.lifespan(0.5)
          ])

          k.trigger("score", "score-text", -10 * items.length)
          this.walkAway()
        } else {

          errors += 1
          this.add([
            k.sprite("cross"),
            k.anchor("center"),
            k.scale(0.7),
            k.pos(-20, -15 * errors),
            "cross",
          ])
        }

      },
      walkAway() {

        this.wait(0.5, () => {
          currentCustomer = null
        })

        this.wait(1, () => {
          this.tween(this.pos, k.vec2(700, this.pos.y), 2, (p) => this.pos = p, k.easings.linear).then(() => {

            this.destroy()
          })
        })
      },
      checkDoneCustomer() {
        const remainingItemCount = items.filter((el) => !el.done)

        if (remainingItemCount == 0) {
          // Walk away the customer
          menu.destroy()

          // Add hearth animation 
          const offsetPosition = this.pos.add(k.vec2(0, -64))
          k.add(makeHearthComps(offsetPosition, 0.4, k.vec2(-32, 5)))
          k.add(makeHearthComps(offsetPosition, 0.4, k.vec2(-10, -2)))
          k.add(makeHearthComps(offsetPosition, 0.4, k.vec2(10, 0)))

          currentCustomer.ready = false

          // Add shopping bag
          this.add([k.sprite("bag"), k.scale(0.6), k.pos(0, -5), k.anchor("bot"), k.z(10)])

          // Trigger Score
          k.trigger("score", "score-text", 10 * items.length)
          k.play("happy", {
            detune: 200,
          })

          this.walkAway()
        }
      },
      validateNewItem(item) {


        // check same flower type

        const firstNotDoneItem = items[currentItemIndex]


        if (firstNotDoneItem.name != item.name || angleDistance(firstNotDoneItem.angle, item.angle) > 25) {
          this.addError()
          k.shake()
          return false
        }


        firstNotDoneItem.done = true
        menu.updateItem(currentItemIndex)
        currentItemIndex++

        this.checkDoneCustomer()

        return true
      },

      showMenu() {
        menu.hidden = false
        isMenuVisible = true
      },
      hideMenu() {
        menu.hidden = true
        isMenuVisible = false
      }
    }
  }




  function makeShopBubble(itemsToBuy) {

    const itemsCount = itemsToBuy.length



    const body = k.make([
      k.pos(0, -40),
      k.anchor("left"),
      k.rect(itemsCount * 32, 32),
      k.color(backgroundColor),
      k.scale(0.5),
      k.timer(),
      "shopper",
      {
        items: [],
        updateItem(index) {
          this.items[index].opacity = 0
        }
      }
    ])

    itemsToBuy.forEach((elem, i) => {
      const newItem = body.add([
        k.pos(i * 32, 0),
        k.anchor("center"),
        k.opacity(1),
        k.rotate(elem.angle),
        k.sprite(elem.name),
      ])

      body.items.push(newItem)
    })


    return body

  }


  function makeBlobComps() {

    const body = k.make([
      k.pos(-64, stopPoint.pos.y),
      k.sprite("blob", { anim: "idle" }),
      k.anchor("bot"),
      k.scale(3),
      shopper(),
      k.timer(),
      "blob",
      {
        ready: false
      }
    ])


    body.tween(body.pos, stopPoint.pos, 1, (p) => body.pos = p, k.easings.linear).then(() => {
      // show menu
      body.ready = true
      body.showMenu()
    })



    return body

  }

  function makeHearthComps(pos, start_opacity, offset) {

    return [
      k.opacity(start_opacity),
      k.sprite("hearth"),
      k.z(10),
      k.pos(pos.add(offset)),
      k.lifespan(0.5, {
        fade: 1
      }),
      k.move(k.vec2(0, -1), 100)
    ]

  }

  function makePreviewPlantComps(plant_name) {

    const body = k.make([
      k.pos(k.center()),
      k.anchor("center"),
      k.color(backgroundColor),
      k.outline(5, foregroundColor),
      k.rect(135, 135),
      "preview-body"
    ])


    const flower = body.add([
      k.anchor("center"),
      k.sprite(plant_name),
      k.scale(3.8),
      k.rotate(),
    ])

    flower.onKeyDown("right", () => {
      flower.rotateBy(+FLOWER_ROTATION_SPEED * k.dt())
    })

    flower.onKeyDown("left", () => {
      flower.rotateBy(-FLOWER_ROTATION_SPEED * k.dt())
    })

    flower.onKeyPress("space", () => {

      const shopper = k.get("shopper")[0]
      if (!shopper.validateNewItem({ name: plant_name, angle: flower.angle })) {
        console.log("error")
      }

      k.play("click")

      body.destroy()
    })

    return body
  }


  function makeFloatingTextScroll(text, onStop) {
    const body = k.make([
      k.text("+" + text),
      k.pos(0, 20),
      k.color(foregroundColor),
      k.scale(0.8),
      k.opacity(0.6),
      k.anchor("topright"),
      k.timer()
    ])

    body.tween(body.pos, k.vec2(0, 0), 0.5, (p) => body.pos = p, k.easings.linear).then(() => {
      onStop()
      body.destroy()
    })

    return body
  }

  k.loadRoot("./"); // A good idea for Itch.io publishing later



  const sceneTimer = k.add([
    k.timer()
  ])



  const stopPoint = k.add([
    k.pos(100, 450),
    "stop-point"
  ])


  function makeShopSpots(pos, plant_name) {
    return [
      k.pos(pos),
      k.sprite(plant_name),
      k.scale(0.5)
    ]
  }

  const shop = k.add([
    k.pos(420, k.height() - 50),
    k.anchor("bot"),
    k.scale(3.5),
    k.sprite("shop", {
      anim: "idle"
    })
  ])

  shop.add(makeShopSpots(k.vec2(-39, -19), "plant_1"))
  shop.add(makeShopSpots(k.vec2(-18, -19), "plant_2"))
  shop.add(makeShopSpots(k.vec2(3, -18), "plant_3"))
  shop.add(makeShopSpots(k.vec2(25, -18), "plant_4"))

  k.add([
    k.pos(k.center()),
    k.color(backgroundColor),
    k.anchor("top"),
    k.z(-20),
    k.rect(k.width(), k.height()),
    k.outline(10, foregroundColor)

  ])


  let currentCustomer = null

  sceneTimer.loop(2, () => {
    if (!currentCustomer)
      currentCustomer = k.add(makeBlobComps())

  })


  // Flower Selector
  k.onKeyPress((key) => {
    if (isDigit(key)) {

      if (!currentCustomer)
        return

      if (+key > MAX_PLANT_NUMBER)
        return

      if (!currentCustomer.ready)
        return

      const alreadyPresentPreview = k.get("preview-body")[0]

      if (alreadyPresentPreview)
        alreadyPresentPreview.destroy()


      k.play("click")
      k.add(makePreviewPlantComps("plant_" + key))
    }
  })

  const scoreText = k.add([
    k.text("0"),
    k.color(foregroundColor),
    k.pos(k.width() - 10, 10),
    k.anchor("topright"),
    "score-text",
    {
      score: 0,
      updateScore(newScore) {
        this.score = parseInt(this.score) + parseInt(newScore)
        this.text = this.score
      }
    }
  ])

  const clock = k.add([
    k.anchor("center"),
    k.pos(k.width() / 2, 64),
    k.sprite("clock"),
    k.scale(4)
  ])

  const clockText = clock.add([
    k.text("60"),
    k.opacity(),
    k.anchor("center"),
    k.color(foregroundColor),
    k.timer(),
    k.scale(0.2),
    {
      time: 60
    }
  ])

  clockText.loop(1, () => {
    clockText.time -= 1
    clockText.text = clockText.time

    if (clockText.time <= 0)
      k.add(makeTransitionComps(k, () => {
        k.go("end", scoreText.score)
      }))
  })



  generateStars(k, 50)

  k.on("score", "score-text", (obj, newScore) => {
    scoreText.add(makeFloatingTextScroll(newScore, () => {
      scoreText.updateScore(newScore)
    }))
  })

}

